// Module
var code = `<customer-page mode="'GROUP'">
  <sub-header header="'Group loan check release'"></sub-header>
  <form-section form-title="'Group loan information per client'">
    <group-loan-information loans="\$ctrl.groupLoan.individualLoans"></group-loan-information>
  </form-section>

  <div class="alert alert--danger" ng-if="!\$ctrl.computeTotalReleaseAmount()">
    At least one selected loan is required
  </div>

  <form-section form-title="'Release group loan by cashier\\'s check'">

    <form name="\$ctrl.transactionForm">
      <validator condition="\$ctrl.computeTotalReleaseAmount()"></validator>
      <table class="table">
        <tbody>
        <tr>
          <td>1.</td>
          <td>Check number:</td>
          <td>
            <input
              type="text"
              ng-model="\$ctrl.checkNumber"
              maxlength="32"
              ng-required="true"/>
          </td>
        </tr>
        <tr>
          <td>2.</td>
          <td>Total amount:</td>
          <td><cash value="\$ctrl.computeTotalReleaseAmount()" ng-disabled="true"></cash></td>
        </tr>
        </tbody>
      </table>

      <div class="labelled-field">
        <label class="caption">Remarks</label>
        <input type="text" ng-model="\$ctrl.remarks" required>
      </div>

      <div class="buttons">
        <button
          class="misc-transaction__cancel btn btn-warning"
          ng-click="\$ctrl.cancelChanges()">
          Cancel
        </button>
        <button
          type="submit"
          class="misc-transaction__save btn btn-success"
          ng-disabled="\$ctrl.transactionForm.\$invalid"
          ng-click="\$ctrl.save()">
          Release
        </button>
      </div>
    </form>
  </form-section>
</customer-page>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/check-release/group-loan-check-release.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;